import * as Yup from 'yup';
import { PageType } from 'common/enums/page-type.enum';

const stringShouldNotBeEmpty = 'This field is required, must be a non empty string';
const valueMustBeString = 'The value must be a string';
const valueMustBeBoolean = 'This field must be a boolean value';
const booleanShouldBeSet = 'This field is required, must be a boolean value';
const dateShouldBeSet = 'Date should be set';
const valueMustBeDate = 'The value must be a date';
const activeToMustBeAfterActiveFrom = 'Valid to must be after Valid from';
const altTextMinimumCharacterLengthError = 'Alt text should be at least 10 characters long';
const sourceArrayShouldNotBeEmpty = 'Source must contain at least one item';
const sourceIsRequired = 'Source is required';
const positionIsRequired = 'Position is required';
const valueMustBeNumber = 'The value must be a number';

const deviceContentSchema = Yup.object().shape({
  available: Yup.boolean()
    .typeError(valueMustBeBoolean)
    .required(booleanShouldBeSet),
  body: Yup.string()
    .typeError(valueMustBeString),
  bannerBackgroundColor: Yup.string()
    .typeError(valueMustBeString)
    .when(['available', 'src', 'hasGiftFinder'], {
      // eslint-disable-next-line max-len
      is: (available: boolean, src: string, hasGiftFinder: boolean) => (available && !src && !hasGiftFinder),
      then: Yup.string().required(stringShouldNotBeEmpty),
    }),
  src: Yup.string()
    .typeError(valueMustBeString)
    .when(['available', 'bannerBackgroundColor', 'hasGiftFinder'], {
      // eslint-disable-next-line max-len
      is: (available: boolean, bannerBackgroundColor: string, hasGiftFinder: boolean) => (available && !bannerBackgroundColor && !hasGiftFinder),
      then: Yup.string().required(stringShouldNotBeEmpty),
    }),
  altText: Yup.string()
    .min(10, altTextMinimumCharacterLengthError)
    .typeError(valueMustBeString)
    .when(['available', 'src', 'hasGiftFinder'], {
      // eslint-disable-next-line max-len
      is: (available: boolean, src: string, hasGiftFinder: boolean) => (available && src && !hasGiftFinder),
      then: Yup.string().required(stringShouldNotBeEmpty),
    }),
  hasGiftFinder: Yup.boolean().typeError(valueMustBeBoolean).required(booleanShouldBeSet),
  url: Yup.string()
    .typeError(valueMustBeString)
    .when(['available', 'hasGiftFinder'], {
      is: (available: boolean, hasGiftFinder: boolean) => (available && !hasGiftFinder),
      then: Yup.string().required(stringShouldNotBeEmpty),
    }),
}, [['bannerBackgroundColor', 'src']]);

export const bannerWidgetSchema = Yup.object().shape({
  name: Yup.string().min(1).required()
    .typeError(valueMustBeString)
    .required(stringShouldNotBeEmpty),
  sources: Yup.array().of(Yup.string())
    .min(1, sourceArrayShouldNotBeEmpty)
    .required(sourceIsRequired),
  position: Yup.number()
    .typeError(valueMustBeNumber)
    .when('pageType', {
      is: PageType.Plp,
      then: Yup.number().required(positionIsRequired),
    }),
  pageType: Yup.string().min(1)
    .typeError(valueMustBeString),
  activeFrom: Yup.date()
    .typeError(valueMustBeDate)
    .required(dateShouldBeSet),
  activeTo: Yup.date()
    .typeError(valueMustBeDate)
    .when('activeFrom', (activeFrom) => Yup.date().min(
      activeFrom,
      activeToMustBeAfterActiveFrom,
    ))
    .required(dateShouldBeSet),
  content: Yup.object({
    desktop: deviceContentSchema,
    mobile: deviceContentSchema,
  }),
});
